import * as React from "react";
import { Redirect, Route, Switch } from "react-router";
import Auth from "~/pages/Auth";
import ProductImageModeration from "~/pages/ProductImageModeration";
import ProductOptionApproval from "~/pages/ProductOptionApproval";
import ProductOptionFix from "~/pages/ProductOptionFix";
import ProductOptionModeration from "~/pages/ProductOptionModeration";

export default class Routes extends React.Component {
  public render() {
    return (
      <Switch>
        <Route
          strict={true}
          path="/product_images/moderate"
          component={ProductImageModeration}
        />
        <Route
          strict={true}
          path="/product_option_images/moderate"
          component={ProductOptionModeration}
        />
        <Route
          strict={true}
          path="/product_option_images/approve"
          component={ProductOptionApproval}
        />
        <Route
          strict={true}
          path="/product_option_images/fix"
          component={ProductOptionFix}
        />
        <Route strict={true} path="/auth" component={Auth} />
        <Redirect to="/product_images/moderate" />
      </Switch>
    );
  }
}



// WEBPACK FOOTER //
// ./src/routes.tsx